export default "__VITE_ASSET__VYv1EB7C__"